module.exports = new __parcel__URL__("ping.84740ffe.wav").toString();